<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <project-field-form-group
        :submissionId="submissionId"
        :formLabel="'Project / Grower'"
      />
      <div v-if="samples && samples.length">
        <hr />
        <template v-for="(sample, index) in samples">
          <project-water-sample-form-group
            :key="index"
            :submissionId="submissionId"
            :sampleId="sample.test_package_sample_id"
            :addOns="addOns"
            :usageOptions="usage_options"
            @updateSampleList="updateSampleList"
          />
        </template>
      </div>
      <b-row class="my-3" align-h="end">
        <b-col cols="2">
          <b-button @click="updateSampleList('add')" variant="success" block>
            <i class="fa fa-plus" /> Add Sample
          </b-button>
        </b-col>
      </b-row>
      <turn-around-select
        :submissionId="submissionId"
        :turnArounds="turnArounds"
      />
      <div v-if="serviceQuestions && serviceQuestions.length">
        <hr />
        <template v-for="(question, index) in serviceQuestions">
          <service-question
            :key="index"
            :serviceQuestion="question"
          />
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import ProjectWaterSampleFormGroup from "./ProjectWaterSampleFormGroup";
import ProjectFieldFormGroup from "../../misc/ProjectFieldFormGroup";
import TurnAroundSelect from "../../misc/TurnAroundSelect";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectWaterSubmissionForm",
  components: {
    TurnAroundSelect,
    ProjectWaterSampleFormGroup,
    ProjectFieldFormGroup
  },
  props: {
    submissionId: {
      type: String,
      default: ""
    },
    serviceQuestions: {
      type: Array,
      default: () => []
    },
    turnArounds: {
      type: Array,
      default: () => []
    },
    addOns: {
      type: Array,
      default: () => []
    },
    managedLists: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission"
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    samples() {
      return this.currentSubmission.samples;
    },
    usage_options() {
      return this.createOptionList(
        this.managedLists.find(
          item => item.sub_type === "water" && item.list === "usage"
        ).attribute_lists,
        "usage"
      );
    }
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate(value, field) {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value,
        name: field
      });
    },
    updateSampleList(action, id) {
      const lastSample = this.samples[this.samples.length - 1];
      let listUpdate;
      switch (action) {
        case "add":
          console.log('adding...', this.samples)
          console.log('last sample', lastSample)
          listUpdate = [
            ...this.samples,
            {
              ...lastSample,
              test_package_sample_id: this.$uuid.v4(),
              identifier: `Sample ${this.samples.length + 1}`,
              add_ons: lastSample && lastSample.add_ons ? [...lastSample.add_ons] : [],
              sample_water: lastSample && lastSample.sample_water ? { ...lastSample.sample_water } : {}
            }
          ];
          console.log('breaking...')
          break;
        case "remove":
          listUpdate = this.samples.filter(
            sample => sample.test_package_sample_id !== id
          );
          break;
        default:
      }
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: listUpdate,
        name: "samples"
      });
    },
    createOptionList(list, field) {
      return {
        options: list.map(item => {
          return { id: item.id, name: item.value, parent_id: item.parent_id };
        }),
        field
      };
    }
  }
};
</script>
